import { createI18n } from "vue-i18n";
import it from '@/assets/i18n/it.json';

const i18n = createI18n({
  locale: 'it',
  messages: {
    it: it
  }
})

export default i18n;